import {
  FALLBACK_PRODUCT_LABEL,
  findProduct,
} from '../../../common/constants/products'
import type {
  ProductName,
  ProductType,
} from '../../../common/constants/products'
import { parseBibeHostname } from '@buffer-mono/shared-utils/bibe'

export function getActiveProduct(): ProductType | null {
  const { productSubdomain } = parseBibeHostname(window.location.hostname)
  const currentPath = window.location.pathname.split('/')[1]

  const condition = ({
    subdomain,
    pathname,
    activeOnMatch,
  }: ProductType): boolean => {
    // match by subdomain and current path first
    return (
      subdomain === productSubdomain &&
      (activeOnMatch?.test(currentPath) ?? currentPath === pathname)
    )
  }

  const fallbackCondition = ({ subdomain, pathname }: ProductType): boolean => {
    // match by subdomain and empty pathname
    return subdomain === productSubdomain && pathname === ''
  }

  return findProduct(condition) ?? findProduct(fallbackCondition) ?? null
}

export function getActiveProductFromUrl(): ProductName | null {
  const activeProduct = getActiveProduct()

  return activeProduct?.id ?? null
}

export function getActiveProductName(): string {
  const activeProduct = getActiveProduct()
  return activeProduct?.label ?? FALLBACK_PRODUCT_LABEL
}

export function isOnboardingPage(): boolean {
  return (
    getActiveProductFromUrl()?.toString() === 'account' &&
    window.location.pathname.includes('onboarding')
  )
}
